import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { initTempDashboard } from '@store/errorDiagnostics/tempDashboard/actions';
import tempDashboardSelector from '@store/errorDiagnostics/tempDashboard/selectors';
import { tempDashboardSelector as errorDiagnosticsTempDashboardSelector } from '@store/errorDiagnostics/selectors';
import { DASHBOARD_TYPE } from '@utils/constants';
import ErrorDiagnostics from './ErrorDiagnostics';
import tempDashboard from '../common/tempDashboard';

const tempDashboardDetailsSelector = createSelector(
  errorDiagnosticsTempDashboardSelector,
  tempDashboardSelector,
  (dashboard, tempDashboardStore) => ({
    dashboard,
    dashboardType: DASHBOARD_TYPE.ERROR_DIAGNOSTICS,
    isFetching: tempDashboardStore.isFetching,
  }),
);

const TempDashboardErrorDiagnostics = compose(
  connect(tempDashboardDetailsSelector, { init: initTempDashboard }),
  tempDashboard,
)(ErrorDiagnostics);

export default TempDashboardErrorDiagnostics;
